import React, { useState } from 'react';
import { Button, Modal, Tooltip, message, notification } from 'antd';
import { AlignCenterOutlined, DownloadOutlined } from '@ant-design/icons';

type Props = {
    onClick: () => Promise<any>;
};

const DownloadBinariesModal = ({ onClick }: Props) => {
    const [open, setOpen] = useState(false);
    const [confirmLoading, setConfirmLoading] = useState(false);
    const [modalText, setModalText] = useState('');
    const [description , setDescription] = useState("Downloading your files!");

    const showModal = () => {
        setOpen(true);
    };

    const handleOk = async () => {
      setOpen(false);
      setConfirmLoading(true);
      setModalText(description);
      await onClick();
      setConfirmLoading(false);
      // setModalText('');
      // message.success('Files Downloaded');
    };

    const handleCancel = () => {
        console.log('Clicked cancel button');
        setOpen(false);
 
    };

    return (
        <>
            <Tooltip title='Download All'>
                <Button type='link' icon={<DownloadOutlined />} onClick={showModal}></Button>
            </Tooltip>
            <Modal
                title='Are you sure you want to Download all files?'
                open={open}
                onOk={handleOk}
                confirmLoading={confirmLoading}
                width={450}
                onCancel={handleCancel}
                okText='Download'
                cancelText='Cancel'
                okButtonProps={{style: {alignContent: 'center', alignItems:'center', justifyContent:'center'}}} 
                cancelButtonProps={{style: {alignContent: 'center', alignItems:'center', justifyContent:'center'}}} 
                // style={{textAlign: 'center',}}
                
            >
                <p className='modaltext'>{modalText}</p>
            </Modal>
        </>
    );
};

export default DownloadBinariesModal;


